import { createSelector } from 'reselect';
import { statsLeadersSelector } from './simple-selectors';

export const statsLeadersNavSelector = createSelector(
    statsLeadersSelector,
    (statsLeaders) => statsLeaders.nav
);
